import React, { Component } from "react";
import {
  Row,
  Col,
  Form,
  Button,
  Card,
  Input,
  message,
  Select,
  Spin,
} from "antd";
import axios from "services/axios";

const FormItem = Form.Item;
const { Option } = Select;

class BusinessAreaUpdate extends Component {
  constructor(props) {
    super(props);
    this.state = {
      area: {},
      directorUsers: [],
      pricingAreas: [],
      isLoading: false,
    };
  }

  componentDidMount() {
    this.fetchDirector();
    this.fetchBusinessAreaById(this.props.match.params.id);
  }

  async fetchDirector() {
    const {
      data: { directorUsers },
    } = await axios.get(`/misc/director-users`);
    this.setState({ directorUsers });
  }

  async fetchBusinessAreaById(id) {
    const {
      data: { area },
    } = await axios.get(`/admin-panel/business-area/${id}`);
    this.setState({ area });
  }

  async updateBusinessArea(e) {
    e.preventDefault();
    this.props.form.validateFieldsAndScroll((err, values) => {
      this.setState({ isLoading: true });
      if (!err) {
        let id = this.props.match.params.id;
        axios
          .patch(`/admin-panel/business-area/${id}/update`, values)
          .then(result => {
            message.success(`Berhasil update Area ${values.name}`);
            this.props.history.push(`/home/business-area`);
          })
          .catch(err => {
            this.errorMessage(err);
          });
      }
      this.setState({ isLoading: false });
    });
  }

  callback(key, props) {
    props.form.resetFields();
  }

  errorMessage(e) {
    if (e.response) {
      if (e.response.data || e.response.message) {
        message.error(
          e.response.data.message || e.response.message || e.response.data
        );
      } else {
        message.error("Error Update Area");
      }
    } else {
      message.error("Error Update Area");
    }
  }

  render() {
    const { getFieldDecorator } = this.props.form;
    return (
      <Card title="Update Business Area">
        <Spin tip="Sedang mengupdate Area" spinning={this.state.isLoading}>
          <Form onSubmit={e => this.updateBusinessArea(e)}>
            <FormItem label="Area">
              {getFieldDecorator("area", {
                initialValue: this.state.area ? this.state.area.area : "",
                rules: [{ required: true, message: "Area wajib diisi" }],
              })(<Input />)}
            </FormItem>

            <FormItem label="ABM">
              {getFieldDecorator("directorsId", {
                initialValue: this.state.area
                  ? this.state.area.directorsId
                  : "",
              })(
                <Select
                  showSearch
                  optionFilterProp="children"
                  filterOption={(input, option) =>
                    option.props.children
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  }
                  placeholder="Select a ABM">
                  {this.state.directorUsers.map((val, index) => (
                    <Option key={index} value={val.id}>
                      {val.User ? val.User.name : ""}
                    </Option>
                  ))}
                </Select>
              )}
            </FormItem>

            <Row type="flex" justify="end">
              <Col>
                <Button htmlType="submit" type="primary">
                  Update
                </Button>
              </Col>
            </Row>
          </Form>
        </Spin>
      </Card>
    );
  }
}

export default Form.create()(BusinessAreaUpdate);



// WEBPACK FOOTER //
// src/components/Dashboard/Area/BusinessArea/BusinessAreaUpdate.js